module.exports = __webpack_public_path__ + "static/img/naniungo-slide-12.d5ed1b4f.jpg";